const PRO_LINK_TEXT = {
  en: 'Remove ads. Go Pro.',
  fr: 'Désactiver les pubs. Passez Pro.'
};

const DEFAULT_ADVERTISEMENT_LABEL = {
  en: 'Advertisement',
  fr: 'Publicité'
};

function resolveLanguage(config, frLang) {
  const supportsFrench = Boolean(config && config.language && config.language.supportsFrench);
  if (!supportsFrench) {
    return 'en';
  }

  if (frLang === 'fr') {
    return 'fr';
  }

  if (typeof window !== 'undefined') {
    const pathname = String(window.location?.pathname || '');
    if (/^\/fr(?:\/|$)/i.test(pathname)) {
      return 'fr';
    }
  }

  return 'en';
}

function getProLinkText(language) {
  return PRO_LINK_TEXT[language] || PRO_LINK_TEXT.en;
}

function getDefaultAdvertisementLabel(language) {
  return DEFAULT_ADVERTISEMENT_LABEL[language] || DEFAULT_ADVERTISEMENT_LABEL.en;
}

/**
 * @param {number} [minHeight] content-box height (px) reserved for the CSA
 *   iframe, which renders only once it nears the viewport
 */
function buildRelatedSearchContainerHtml(minHeight) {
  const height = Number(minHeight);
  return Number.isFinite(height) && height > 0
    ? `<div id="relatedsearches1" style="min-height:${height}px"></div>`
    : '<div id="relatedsearches1"></div>';
}

function getSlotPath(config, device, slotKey) {
  if (!config || !config.slots || !config.slots[device]) return '';
  const slot = config.slots[device][slotKey];
  if (!slot) return '';
  return `${config.gamNetwork}/${slot}`;
}

function emitAdEvent(emitter, brand, event, payload) {
  if (emitter && typeof emitter.emit === 'function') {
    emitter.emit(`ads:${brand}:${event}`, payload);
  }
}

module.exports = {
  resolveLanguage,
  getProLinkText,
  getDefaultAdvertisementLabel,
  buildRelatedSearchContainerHtml,
  getSlotPath,
  emitAdEvent
};
